import React from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "./index";

// Form-aware Button: submits the surrounding react-hook-form and auto-disables
// while the form has validation errors. Keeps form logic out of the base Button.
function SubmitButton({ disabled = false, ...props }) {
  const { formState } = useFormContext();
  const hasErrors = Object.keys(formState.errors).length > 0;

  return <Button {...props} type="submit" disabled={disabled || hasErrors} />;
}

export { SubmitButton };
